import { render, staticRenderFns } from "./Form20ProcessHeader.vue?vue&type=template&id=201f67ab&scoped=true"
import script from "./Form20ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form20ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form20ProcessHeader.vue?vue&type=style&index=0&id=201f67ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f67ab",
  null
  
)

export default component.exports